/*
 * @Description: 新增、编辑收付通商户中各面板共用的数据
 * @Author: sunhuihong
 * @Date: 2022-10-21 18:28:58
 */
import Vue from 'vue'
import Vuex from 'vuex'
Vue.use(Vuex);

const state = {
    mode: '',
    commonMchForm : {
        bankAccount : {},
        merchant : {}
    },
    mchFormData: {},
    srcProvinceList: [],
    srcCityList: [],
    srcBranchesList: [],
    bizLicenseFile: null,
    idCardImg1File: null,
    idCardImg2File: null,
}

const mutations = {
    changeMode(stateN, mode) {
        stateN.mode = mode;
    },

    changeMchFormData(stateN, mchFormData) {
        stateN.commonMchForm.bankAccount = mchFormData.bankAccount;
        stateN.commonMchForm.merchant = mchFormData.merchant;
        stateN.mchFormData = mchFormData;
    },

    changeSrcProvinceList(stateN, srcProvinceList) {
        stateN.srcProvinceList = srcProvinceList;
    },

    changeSrcCityList(stateN, srcCityList) {
        stateN.srcCityList = srcCityList;
    },

    changeSrcBranchesList(stateN, srcBranchesList) {
        stateN.srcBranchesList = srcBranchesList;
    },

    changeCommonMchForm(stateN, mchFormData) {
        stateN.commonMchForm.bankAccount = mchFormData.bankAccount;
        stateN.commonMchForm.merchant = mchFormData.merchant;
    },
    
    changeBizLicenseFile(stateN, bizLicenseFile) {
        stateN.bizLicenseFile = bizLicenseFile;
    },

    changeIdCardImg1File(stateN, idCardImg1File) {
        stateN.idCardImg1File = idCardImg1File;
    },

    changeIdCardImg2Path(stateN, idCardImg2File) {
        stateN.idCardImg2File = idCardImg2File;
    },

}

export default new Vuex.Store({
    state: state,
    mutations: mutations
})


// WEBPACK FOOTER //
// ./src/components/mchmng/components/MchStore.js